// import _ from 'lodash'

export default {
  name: 'RuleService',
  props: ['quick_setting', 'ico'],
  computed: {},
  watch: {
    quick_setting() {
      // console.log('quick setting changed', this.quick_setting)
      this.setting = this.quick_setting
    }
  },
  data: () => {
    return {
      step : 1,
      setting : undefined
    }
  },
  methods: {
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    toggle($value, key, type) {
      location.hostname == 'localhost' ? console.info('update toggle policy RuleService => parent', $value, key, type) : ''
      key.forEach(k => this.$parent.$emit('toggle_policy', $value, k, type))
    }
  },
  created: function() {   console.log('RuleService.vue', 'created'); },
  destroyed: function() { console.log('RuleService.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleService.vue', 'mounted');
    this.setting = this.quick_setting
  }
}
